import { Button } from '@latitude/button';
import { Text } from '@latitude/text';
import React from 'react';

type FlagHeaderProps = {
  hasOverrides: boolean;
  onResetAll: () => void;
};

export const FlagHeader: React.FC<FlagHeaderProps> = ({
  hasOverrides,
  onResetAll,
}) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <Text variant="headingMedium">Feature flags</Text>
        <Button
          type="outline"
          variant="neutral"
          size="small"
          onClick={onResetAll}
          disabled={!hasOverrides}
        >
          Reset Overrides
        </Button>
      </div>
      <Text className="mt-2" variant="bodyRegular" color="muted">
        Configure feature flags for local development. Values are resolved from:
        LocalStorage → LaunchDarkly → Defaults
      </Text>
    </>
  );
};
